import { useState } from "react";
import type { FormEvent } from "react";

interface Comment {
  id: number;
  name: string;
  content: string;
  date: string;
  avatarTone: string;
}

const seedComments: Comment[] = [
  {
    id: 1,
    name: "金价观察者",
    content: "行情刷新很快，多屏看盘对我这种盯盘的人很友好，指标组合也挺全的，推荐给做短线的朋友。",
    date: "2026-10-05",
    avatarTone: "bg-primary-500 text-foreground-950",
  },
  {
    id: 2,
    name: "稳健理财张",
    content: "主要用它的预警功能，设好价格区间就不用一直盯着了，到价有推送，省心不少。",
    date: "2026-09-29",
    avatarTone: "bg-accent-500 text-background-50",
  },
  {
    id: 3,
    name: "小散一枚",
    content: "界面挺清爽的，新手引导也做得不错，希望能一直免费就好。",
    date: "2026-09-21",
    avatarTone: "bg-secondary-500 text-background-50",
  },
];

export default function CommentSection({ softwareName }: { softwareName: string }) {
  const [comments, setComments] = useState<Comment[]>(seedComments);
  const [name, setName] = useState("");
  const [content, setContent] = useState("");
  const [notice, setNotice] = useState<string | null>(null);

  const submit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const honeypot = (e.currentTarget.elements.namedItem("contact_alt") as HTMLInputElement)?.value;
    if (honeypot && honeypot.trim() !== "") {
      setNotice("评论已提交（演示）");
      return;
    }
    if (!content.trim()) {
      setNotice("请先填写评论内容");
      return;
    }
    const next: Comment = {
      id: Date.now(),
      name: name.trim() || "匿名用户",
      content: content.trim().slice(0, 500),
      date: new Date().toISOString().slice(0, 10),
      avatarTone: "bg-primary-500 text-foreground-950",
    };
    setComments((prev) => [next, ...prev]);
    setName("");
    setContent("");
    setNotice("评论已发布（演示功能，仅本地展示，不会保存到服务器）");
  };

  return (
    <section>
      <h2 className="mb-3 flex items-center gap-2 font-heading text-lg font-bold text-foreground-900">
        <i className="ri-chat-3-line text-primary-600" />
        用户评论
        <span className="text-sm font-normal text-foreground-500">（{comments.length}）</span>
      </h2>

      <form className="card-surface flex flex-col gap-3 p-4" onSubmit={submit}>
        <div className="flex flex-col gap-3 sm:flex-row">
          <input
            name="nickname"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="你的昵称（选填）"
            maxLength={20}
            className="h-10 w-full rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-400 sm:w-44"
          />
        </div>
        <textarea
          name="content"
          value={content}
          onChange={(e) => setContent(e.target.value.slice(0, 500))}
          placeholder={`说说你对「${softwareName}」的使用感受…`}
          rows={3}
          maxLength={500}
          className="w-full resize-none rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-400"
        />
        <input
          type="text"
          name="contact_alt"
          className="aux-field-guard"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
        />
        <div className="flex flex-wrap items-center justify-between gap-3">
          <span className="text-xs text-foreground-500">{content.length}/500</span>
          <button type="submit" className="btn-primary text-sm">
            <i className="ri-send-plane-line" />
            发表评论
          </button>
        </div>
        {notice && (
          <p className="rounded-md bg-background-100 px-3 py-2 text-xs text-foreground-600">
            {notice}
          </p>
        )}
      </form>

      <ul className="mt-4 flex flex-col gap-3">
        {comments.map((item) => (
          <li key={item.id} className="card-surface flex gap-3 p-4">
            <span
              className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-bold ${item.avatarTone}`}
            >
              {item.name.slice(0, 1)}
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex items-center justify-between gap-2">
                <span className="text-sm font-semibold text-foreground-900">{item.name}</span>
                <span className="shrink-0 text-xs text-foreground-400">{item.date}</span>
              </div>
              <p className="mt-1 text-sm leading-relaxed text-foreground-700">{item.content}</p>
            </div>
          </li>
        ))}
      </ul>
      <p className="mt-3 text-xs text-foreground-400">
        评论为前端演示内容，不会保存到服务器，仅用于展示交互样式。
      </p>
    </section>
  );
}